export default __webpack_public_path__ + "static/media/IMG_3727cropped.d17c4675.jpeg";